import { useSelector } from 'react-redux'

import { useOfferedRecipes } from 'hooks/menu-recipes/useOfferedRecipes'

import { getSignupDietaryPreferences } from '../signupSelectors'
import { getPreferredRecipes } from '../utils/helpers/recipeFiltering/dietaryBasedRecipes'
import { NUMBER_OF_REQUIRED_RECIPES } from '../utils/helpers/recipeFiltering/dietaryBasedRecipesConfig'

export const useRecipesList = () => {
  const offeredRecipes = useOfferedRecipes()

  const dietaryPreferencesRaw = useSelector(getSignupDietaryPreferences)
  const dietaryPreferences = dietaryPreferencesRaw ? dietaryPreferencesRaw.toArray() : []

  return getPreferredRecipes(offeredRecipes, dietaryPreferences, NUMBER_OF_REQUIRED_RECIPES)
}
